<template>
  <transition name="modal-fade" @after-enter="startMoneyAnimation">
    <div v-if="show" class="prize-modal">
      <div class="prize-modal-bg">
        <button class="close-button" @click="close" />
        <div class="money-container money-img" :class="{ 'money-scaled': moneyScaled }" />

        <div class="content">
          <h2 class="congratulations">
            {{ $t("Bao.roulette_congrats") }}
          </h2>
          <p class="sub-text">
            {{ $t("Bao.roulette_shop") }}
          </p>
          <div class="prize-amount">
            {{ displayValue }}
          </div>
          <button class="confirm-button" @click="confirm">
            {{ $t("Bao.roulette_get") }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { CountUp } from 'countup.js'

export default {
  name: 'PrizeModal',
  props: {
    prize: {
      type: [String, Number],
      default: '0'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countUpInstance: null,
      displayValue: '0',
      moneyScaled: false
    }
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.initCountUp(this.prize)
        })
      } else {
        this.displayValue = '0'
        this.moneyScaled = false
        if (this.countUpInstance) {
          this.countUpInstance.reset()
        }
      }
    }
  },
  methods: {
    confirm() {
      this.$emit('prize-confirmed')
    },
    close() {
      this.$emit('close')
    },
    initCountUp(endValue) {
      const options = {
        decimalPlaces: 2,
        duration: 1.4,
        prefix: '¥',
        useEasing: true
      }

      const target = document.querySelector('.prize-amount')
      if (!target) {
        console.error('Target element not found')
        return
      }

      this.countUpInstance = new CountUp(target, Number(endValue), options)

      if (!this.countUpInstance.error) {
        this.countUpInstance.start(() => {
          this.displayValue = this.countUpInstance.formattedValue
        })
      } else {
        console.error(this.countUpInstance.error)
        this.displayValue = endValue.toString()
      }
    },
    startMoneyAnimation() {
      setTimeout(() => {
        this.moneyScaled = true
      }, 1)
    }
  }
}
</script>

<style scoped>
.prize-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.prize-modal-bg {
  position: relative;
  width: 80%;
  height: auto;
  max-width: 400px;
  background-color: #1a1a1a;
  border-radius: 20px;
  padding: 50px;
}

.close-button {
  position: absolute;
  top: -32px;
  right: -18px;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.45rem;
  cursor: pointer;
  z-index: 99;
   border: black;
  border-radius: 50%;
  background:rgba(255, 255, 255, 0.75) url(../../assets/theme_gold/images/icon-close-black.png) center / 1em auto no-repeat;
}

.money-container {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 200%;
  height: 200%;
  transform: translate(-50%, -50%) scale(0.5);
  transition: transform 0.3s cubic-bezier(0.17, 0.17, 0.23, 1);
}

.money-scaled {
  transform: translate(-50%, -50%) scale(1.9);
}

.money-img {
  background-image: url(../../assets/theme_gold/images/money_pop.png);
  background-size: 200px, auto;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: transform 0.05s;
}

.modal-fade-enter, .modal-fade-leave-to {
  transform: scale(0.2);
}

.content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: white;
}

.congratulations {
  font-size: 24px;
  margin-bottom: 10px;
}

.sub-text {
  font-size: 14px;
  margin-bottom: 20px;
}

.prize-amount {
  font-size: 36px;
  font-weight: bold;
  color: gold;
  margin-bottom: 20px;
}

.confirm-button {
  background-color: #b1a781;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 5px;
}
  @media (max-width: 575.98px) {
    .prize-modal-bg {
      width: 90%;
    }
    .close-button{

       right: 0;
      }
     .money-scaled {
        transform: translate(-49%, -50%) scale(1.7);
      }
    }

</style>

